import {
  createBrowserRouter,
  RouteObject,
} from "react-router-dom";

import {
  Router,
} from "@remix-run/router"

import { Dashboard } from "../pages/App/Home";

import { AppLayout } from "../components/layouts/AppLayout";

import { ApiProvider } from "../providers/api/apiProvider";

import { UserRole } from "../models/User";
import { Logs } from "../pages/App/Logs";
import { Contacts } from "../pages/App/Contacts";
import { Error404 } from "../pages/Error";
import { Chat } from "../pages/App/Chats";
import { Shipments } from "../pages/App/Shipments";

const apiProviderRoute: RouteObject = {
  path: "/",
  Component: ApiProvider,
  children: []
};

const notFoundRoute: RouteObject = {
  path: "*",
  Component: Error404,
};

const appLayoutRoute: RouteObject = {
  path: "",
  Component: AppLayout,
  children: []
};

const chatsBaseRoute: RouteObject = {
  index: true,
  Component: Chat,
};

const chatsRoute: RouteObject = {
  path: "/chats",
  Component: Chat,
};

const chatRoute: RouteObject = {
  path: "/chat/:chatId",
  Component: Chat,
};

const shipmentsRoute: RouteObject = {
  path: "/shipments",
  Component: Shipments,
};

const dashboardRoute: RouteObject = {
  index: true,
  Component: Dashboard,
};

const logsRoute: RouteObject = {
  path: "/logs",
  Component: Logs,
};

const contactsRoute: RouteObject = {
  path: "/contacts",
  Component: Contacts,
};

export const appRouter: {
  [ key in UserRole ]: Router;
} = {
  [ UserRole.ADMIN ]: createBrowserRouter([
    {
      ...apiProviderRoute,
      children: [
        {
          ...appLayoutRoute,
          children: [
            dashboardRoute,
            chatsRoute,
            chatRoute,
            shipmentsRoute,
            logsRoute,
            contactsRoute,
          ]
        },
        notFoundRoute,
      ]
    }
  ]),
  [ UserRole.MANAGER ]: createBrowserRouter([
    {
      ...apiProviderRoute,
      children: [
        {
          ...appLayoutRoute,
          children: [
            dashboardRoute,
            chatsRoute,
            chatRoute,
            shipmentsRoute,
            logsRoute,
            contactsRoute,
          ]
        },
        notFoundRoute,
      ]
    }
  ]),
  [ UserRole.ATTENDANT ]: createBrowserRouter([
    {
      ...apiProviderRoute,
      children: [
        {
          ...appLayoutRoute,
          children: [
            chatsBaseRoute,
            chatsRoute,
            chatRoute,
            shipmentsRoute,
          ]
        },
        notFoundRoute,
      ]
    }
  ]),
};
